import type { WallHorizontalDatum } from "building-types/datums/datumsTypesEnum";
import type { DocEntityHandle, RoomHandle } from "building-types/handles/docEntityHandleTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export interface SnapHostEntity {
  readonly handle: DocEntityHandle;
  readonly outline: PolyLine2;
  readonly edgeIndex: number;
  readonly param: number;
  readonly paramNormalized: boolean;
}

export enum WallHostedAnnotationSide {
  OUTSIDE = "OUTSIDE",
  INSIDE = "INSIDE",
}

export interface AnnotationHostEntityBase {
  readonly type: string;
  readonly handle: DocEntityHandle;
  readonly edgeIndex: number;
  readonly param: number;
  readonly paramNormalized: boolean;
}

export interface AnnotationHostWall extends AnnotationHostEntityBase {
  readonly type: "WALL";
  readonly handle: RoomHandle;
  readonly wallSide: WallHostedAnnotationSide;
  readonly horizontalDatum: WallHorizontalDatum;
}

export type AnnotationHostEntity = AnnotationHostWall;

export interface EntityHostedAnnotationPoint {
  readonly hostEntity?: AnnotationHostEntity;
  readonly enabled?: boolean;
}
